import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { Home, Search, ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui';

export function NotFound() {
  const { t } = useTranslation();

  return (
    <div className="relative z-10 min-h-[60vh] flex items-center justify-center">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-center"
      >
        {/* 404 Animation */}
        <motion.div
          animate={{
            y: [0, -10, 0],
          }}
          transition={{
            duration: 2,
            repeat: Infinity,
            ease: 'easeInOut',
          }}
          className="mb-8"
        >
          <span className="text-8xl">🦁</span>
        </motion.div>

        <h1 className="text-6xl font-bold text-gradient mb-4">404</h1>
        <h2 className="text-2xl font-semibold mb-2">{t('notFound.title')}</h2>
        <p className="text-gray-400 mb-8 max-w-md mx-auto">
          {t('notFound.subtitle')}
        </p>

        <div className="flex flex-wrap justify-center gap-4">
          <Link to="/">
            <Button icon={<Home className="w-4 h-4" />}>
              {t('common.goToHome')}
            </Button>
          </Link>
          <Link to="/search">
            <Button variant="secondary" icon={<Search className="w-4 h-4" />}>
              {t('common.search')}
            </Button>
          </Link>
          <Button
            variant="ghost"
            icon={<ArrowLeft className="w-4 h-4" />}
            onClick={() => window.history.back()}
          >
            {t('common.back')}
          </Button>
        </div>
      </motion.div>
    </div>
  );
}
